import { type OrganicStat } from "../../gql-generated/types";
import { computeCountriesPctValue, computeHorizontalBarWidth } from "../computers";
import { getArrayFirstItems } from "../filters";
import { summarizeMetricsArray } from "../math";
import { type CountriesStatsItem, type StatsItem } from "../models";

import { mapStatsArrayToIntValues } from "./mapStatsArrayToIntValues";
import { sortStatsArray } from "./sortStatsArray";

export const mapTopCountryMetrics = (
    stats: readonly OrganicStat[],
    firstTopItems: number,
    keyFormatter?: (value: string) => string,
): CountriesStatsItem[] => {
    const mappedList = mapStatsArrayToIntValues(stats);
    const sortedList = sortStatsArray(mappedList);
    const slicedList = getArrayFirstItems<StatsItem>(sortedList, firstTopItems);

    const totalValue = summarizeMetricsArray(sortedList);

    return slicedList.map(({ key, value }) => ({
        value,
        key: keyFormatter ? keyFormatter(key) : key,
        pct: computeCountriesPctValue(value, totalValue),
        width: computeHorizontalBarWidth(slicedList[0]?.value ?? 0, value),
    }));
};
